
'use client';

import { generateCompareURLByDetailedSlugs } from '@/app/utilities/helper';
import { useRouter } from 'next/navigation';
import React, { useMemo, useState } from 'react';
import Heading from '../Heading';
import ModelSelect from './SearchSelect';

interface CompareBrandModelsProps {
  models: {label: string, value: string, isDisabled?: boolean}[];
  brandName: string;
  trackingClass?: string;
}

const CompareBrandModels: React.FC<CompareBrandModelsProps> = ({ models, brandName, trackingClass }) => {
  const router = useRouter();

  const [model1, setModel1] = useState('');
  const [model2, setModel2] = useState('');
  const [model3, setModel3] = useState('');
  const [model4, setModel4] = useState('');

  const selectedValues = useMemo(
    () => [model1, model2, model3, model4].filter(Boolean),
    [model1, model2, model3, model4]
  );
  const selectedCount = selectedValues.filter(Boolean).length;

  const handleCompare = () => {
    if (selectedCount < 2) {
      return;
    }
    const selected = [model1, model2, model3, model4].filter(Boolean);
    const url = generateCompareURLByDetailedSlugs(selected)
    
    router.push(`/compare-cars/${url}`);
  };

  const updatedModels = useMemo(() => {
    return models.map((opt) => ({
      ...opt,
      isDisabled: selectedValues.includes(opt.value) ,
    }));
  }, [models, selectedValues]);

  return (
    <>
    <section className="mt-6 mb-4">
        <div className="border border-[#00DAD8] rounded-lg">
          <div
            className="bg-[linear-gradient(91.14deg,_rgba(0,140,139,0.14)_-50.06%,_rgba(255,255,255,0.7)_123.25%)] rounded-lg p-3 md:p-4"
          >
            <div className="mb-4">
              <Heading tag="h2" className="font-bold text-2xl md:text-3xl">
                Compare {brandName} Cars
              </Heading>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-4">
              <ModelSelect
                label="Select Model 1"
                value={model1}
                onChange={setModel1}
                options={updatedModels}
                brandName={brandName}
              />
              <ModelSelect
                label="Select Model 2"
                value={model2}
                onChange={setModel2}
                options={updatedModels}
                brandName={brandName}
              />
              <ModelSelect
                label="Select Model 3"
                value={model3}
                onChange={setModel3}
                options={updatedModels}
                brandName={brandName}
              />
              <ModelSelect
                label="Select Model 4"
                value={model4}
                onChange={setModel4}
                options={updatedModels}
                brandName={brandName}
              />
            </div>

            <div className="text-left">
              <button
                onClick={handleCompare}
                disabled={selectedCount < 2}
                className={`inline-block px-5 py-[10px] rounded-md font-semibold text-white transition-colors bg-[#008C8B] w-full md:w-[430px] outline-none ${trackingClass} focus:outline-none focus:ring-0 cursor-pointer 
                  ${
                    selectedCount >= 2
                      ? "cursor-pointer"
                      : "cursor-not-allowed pointer-events-none opacity-50"
                  }`}
              >
                Compare Now
              </button>
            </div>
          </div>
        </div>
    </section>    
    </>
  );
};

export default CompareBrandModels;